import { render, staticRenderFns } from "./pingshen.vue?vue&type=template&id=f2c2ed92&scoped=true"
import script from "./pingshen.vue?vue&type=script&lang=js"
export * from "./pingshen.vue?vue&type=script&lang=js"
import style0 from "./pingshen.vue?vue&type=style&index=0&id=f2c2ed92&prod&scoped=true&lang=scss"
import style1 from "./pingshen.vue?vue&type=style&index=1&id=f2c2ed92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c2ed92",
  null
  
)

export default component.exports